import { render, staticRenderFns } from "./CrearImagenesDerivadas.vue?vue&type=template&id=9dd84f16"
import script from "./CrearImagenesDerivadas.vue?vue&type=script&lang=js"
export * from "./CrearImagenesDerivadas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports